import { APIResponseType, createGetApiHook, createPostApiHook } from "@/shared";
import { axiosInstance } from "@/shared/api/axiosConfig";
import { MutationKey, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { NotificationResponse } from "../types/notification.type";

export type NotificationQueryParams = Record<string, any>;

const getNotificationAPI = (queryParams: NotificationQueryParams = {}): string => {
  const fullParams = {
    ...queryParams,
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/notification?${queryString}`;
};

export const useGetNotification = createGetApiHook<
  APIResponseType<NotificationResponse>,
  NotificationQueryParams
>(getNotificationAPI);

const markAllNotificationAsReadAPI = () => `/notification/mark-all-as-read`;

export type MarkAllNotificationAsReadPayload = {
  talent_id?: number | string;
};

export const useMarkAllNotificationAsRead = createPostApiHook<
  MarkAllNotificationAsReadPayload,
  {},
  APIResponseType<any>
>(markAllNotificationAsReadAPI, {
  isFormDataMethod: false,
});

export type MarkOneNotificationAsReadPayload = {
  notification_id: number;
};

/** Marks a single notification as read. `notification_id` is passed to `update()`. */
export const useMarkOneNotificationAsRead = ({ key }: { key: MutationKey }) => {
  const mutation = useMutation<
    APIResponseType<any>,
    AxiosError,
    MarkOneNotificationAsReadPayload
  >(key, async ({ notification_id }) => {
    const response = await axiosInstance.post(
      `/notification/mark-as-read/${notification_id}`,
      {}
    );
    return response.data;
  });

  return {
    ...mutation,
    update: mutation.mutateAsync,
  };
};
